import type { Report, ResultTotal } from "@/@types/reports";

export function getInboundVoiceTotals(reportData: Report) {
  const dataWithTotals = { ...reportData };
  const total: ResultTotal = {
    queue: "Total",
    atendidas_ns: 0,
    contestadas: 0,
    nivel_abandono: 0,
    nivel_servicio: 0,
    no_contestadas: 0,
    sd: 0,
    total: 0,
    total_seconds: 0,
    umbral_espera: 0,
  };

  reportData.results.forEach((row) => {
    total.atendidas_ns += row.atendidas_ns;
    total.contestadas += row.contestadas;
    total.no_contestadas += row.no_contestadas;
    total.sd += row.sd;
    total.total += row.total;
    total.total_seconds += row.total_seconds ?? 0;
    total.umbral_espera += row.umbral_espera;
  });

  total.nivel_servicio = total.atendidas_ns / total.total;
  total.nivel_abandono = total.no_contestadas / total.total;

  dataWithTotals.total = total;

  return dataWithTotals;
}
